import { api } from '../api';

/**
 * voicecheck 계정 검색 클라이언트
 */

export interface VoiceUserDto {
  id: number;
  /** voicecheck.users.login_id */
  loginId: string;
  name: string;
  status: string;
  /** 이미 입소자(admin_resident)에 매핑되었는지 */
  alreadyMapped: boolean;
  /** alreadyMapped일 때 연결 입소자 호실 번호 (참고용) */
  mappedRoomNumber: string | null;
}

export interface PaginatedVoiceUsers {
  items: VoiceUserDto[];
  total: number;
  page: number;
  limit: number;
}

/**
 * voicecheck 계정 검색
 * @returns {Promise<PaginatedVoiceUsers>}
 */
export async function listVoiceUsers(params?: {
  page?: number;
  limit?: number;
  search?: string;
  /** true면 미매핑 계정만 */
  unmappedOnly?: boolean;
}): Promise<PaginatedVoiceUsers> {
  const res = await api.get<PaginatedVoiceUsers>('/voice-users', { params });
  return res.data;
}
